import type * as THREE from 'three'
import type { LoadOptions } from '@/shared/types/gsplat'

/**
 * 初始化新创建的 3DGS 资产根标准 TRS。
 *
 * position 是相对资源内禀 offset 的附加平移；rotation / scale 绕 asset-local
 * 原点生效，不得通过矩阵后乘污染 offset。
 */
export function applyAssetRootTransform(
  root: THREE.Object3D,
  offset: readonly [number, number, number],
  options?: LoadOptions
): void {
  root.position.set(
    offset[0] + (options?.position?.x ?? 0),
    offset[1] + (options?.position?.y ?? 0),
    offset[2] + (options?.position?.z ?? 0)
  )

  if (options?.rotation) {
    root.rotation.set(options.rotation.x, options.rotation.y, options.rotation.z)
  }
  if (options?.scale) {
    root.scale.set(options.scale.x, options.scale.y, options.scale.z)
  }

  root.updateMatrixWorld(true)
}
